import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { PermissionsService } from 'app/core/authentication';


@Directive({
    selector: '[khIfHasRole]',
    standalone: false
})
export class IfHasRoleDirective implements OnInit {

  public constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    public readonly permissionsService: PermissionsService) { }

  private roles: string[] = [];

  @Input() public set khIfHasRole(roles: string | string[]) {
    if (typeof roles === 'string') {
      this.roles = [roles];
    } else {
      this.roles = roles;
    }
  }

  public ngOnInit(): void {
    let show = true;
    if (this.roles.length > 0) {
      show = this.permissionsService.hasAnyRole(this.roles);
    }
    if (show) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
